import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { StatusRoutingModule } from './status.routing'
import { StatusComponent } from './status.component'
import { AlignerComponent } from './aligner/aligner.component'
import { MailHistoryComponent } from './mail-history/mail-history.component'
import { AuditComponent } from './audit/audit.component'
import { BroadcastMailHistoryComponent } from './broadcast-mail-history/broadcast-mail-history.component'
import { ScrollbarModule } from 'ngx-scrollbar'
import { SharedServices } from '../../../services/shared.services'
import { ShardModule } from '../../../shard.module'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { ChatHistoryComponent } from './chat-history/chat-history.component'

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        StatusRoutingModule,
        ReactiveFormsModule,
        ScrollbarModule,
        ShardModule,
        InfiniteScrollModule,
    ],
    declarations: [
        StatusComponent,
        AlignerComponent,
        MailHistoryComponent,
        AuditComponent,
        BroadcastMailHistoryComponent,
        ChatHistoryComponent,
    ],
    providers: [
        SharedServices,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
})
export class StatusModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/status.module.ts